import './Home.css'
import React from 'react'
import Chats from './Chats'
import Bar from './Bar'
import AddGroup from './AddGroup'

const SideBar = () => {
  return (
    <div className="sidebar">
      <Bar />
      <Chats />
      <AddGroup />
    </div>
  )
}

export default SideBar
